import React from 'react';
import i18next from 'i18next';
import { Helmet } from 'react-helmet';
import TasksList from 'components/TasksList';

/**
 * Main tasks board page wrapper.
 * Uses TasksList component in full mode for displaying all tasks.
 */
export default function TasksBoard() {
  return (
    <>
      <Helmet>
        <title>{i18next.t(`tasks-page-title`)}</title>
      </Helmet>
      <TasksList mode="full" />
    </>
  );
}
